var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prism-editor',{staticClass:"prism-editor",attrs:{"tab-size":4,"highlight":_vm.highlighter,"line-numbers":""},on:{"input":_vm.updateCode},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }